import { render, staticRenderFns } from "./ListAlgolia.vue?vue&type=template&id=1d260985&scoped=true"
import script from "./ListAlgolia.vue?vue&type=script&lang=js"
export * from "./ListAlgolia.vue?vue&type=script&lang=js"
import style0 from "./ListAlgolia.vue?vue&type=style&index=0&id=1d260985&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d260985",
  null
  
)

export default component.exports